import { useEffect, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { application } from "globals/endpoints";
import CTLTableContent from "./CTLTableContent";
import MDBox from "components/MDBox";

const linearStyle = makeStyles((theme) => ({
  root: {
    width: "50%",
    position: "absolute",
    left: "100px",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

function CTLTable({
  onSelectionChange,
  onRowSelectionChange,
  columns,
  apiURL,
  defaultSortColumn,
  defaultSortDirection,
  pageId,
  searchText,
  hasRowSelection,
  advancedFilters,
  onClearFilters,
  updateList,
  disablePagination,
  disableSort,
  refetchInterval,
  defaultPageSize,
  footerContent,
}) {
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sortInfo, setSortInfo] = useState({ sortBy: "", sortDirection: "" });
  const [ids, setIds] = useState([]);
  const [rowData, setRowData] = useState([]);
  const classes = linearStyle();

  const fetchData = useCallback((pageSize, newPage, sortInfo) => {
    fetchAPIData(pageSize, newPage, sortInfo);
  });
  const fetchAPIData = (pageSize, newPage, sortInfo) => {
    try {
      const pageDefinition = {
        currentPage: newPage,
        pageSize: pageSize,
        sortDirection: sortInfo.desc ? "desc" : "asc",
        sortBy: sortInfo.id,
      };
      setLoading(true);

      application
        .post(apiURL, pageDefinition)
        .then((response) => {
          setRows(response.data.data.currentPageData);
          setRowCount(response.data.data.totalRecords);
          setPageIndex(response.data.data.currentPage);
          setSortInfo({
            sortBy: pageDefinition.sortBy,
            sortDirection: pageDefinition.sortDirection,
          });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (e) {
      setLoading(false);
    }
  };

  const ROW_HEIGHT = 32;
  const HEADER_OFFSET = 140;
  const dynamicPageSize = Math.max(10, Math.floor((window.innerHeight - HEADER_OFFSET) / ROW_HEIGHT));

  useEffect(() => {
    fetchData(dynamicPageSize, 0);
  }, []);

  // callback function to handle SelectedId
  function handleIdData(rowSelectionIds) {
    setIds(rowSelectionIds);
    onSelectionChange && onSelectionChange(ids);
  }

  function onSelectedRowData(rowData) {
    setRowData(rowData);
    onRowSelectionChange && onRowSelectionChange(rowData);
  }

  return (
    <MDBox sx={{ display: "flex", flexDirection: "column", height: "calc(100vh - 90px)", minHeight: 0, borderRadius: 0 }}>
      <CTLTableContent
        onSelectedRowData={onSelectedRowData}
        onSelectedIDdata={handleIdData}
        table={{ columns: columns }}
        rowCount={rowCount}
        pageIndex={pageIndex}
        fetchData={fetchData}
        sortInfo={sortInfo}
        apiURL={apiURL}
        defaultSortColumn={defaultSortColumn}
        defaultSortDirection={defaultSortDirection}
        pageId={pageId}
        searchText={searchText}
        hasRowSelection={hasRowSelection}
        advancedFilters={advancedFilters}
        onClearFilters={onClearFilters}
        updateList={updateList}
        disablePagination={disablePagination}
        disableSort={disableSort}
        refetchInterval={refetchInterval}
        defaultPageSize={defaultPageSize}
        footerContent={footerContent}
      />
    </MDBox>
  );
}
export default CTLTable;
